export default {
  '-2000': '未登录',
  '-2001': '参数错误',
  '-2002': '保存数据失败',
  '-2003': '修改数据失败',
  '-2004': '获取数据失败',
  '-2005': 'ID 不能为空',
  '-2006': '数据已经存在',
  '-2007': '数据不存在',
  '-2008': '邮箱非法',
  '-2009': '回复不存在',
  '-2010': '非法的状态',
  '-2011': 'JSON 数据错误',
  '-2012': '导航数据错误',
  '-2013': '类型错误',
  '-2014': '包含敏感词，请重新输入',
  '-4002': '图形验证码错误',
  '-4003': '图形验证码错误',
  '-4004': '图形验证码错误'
}
